<p class="font-bold line-height-2" i18n>
  Directory File (EF_DIR) contains one or more applications (e.g., USIM, ISIM) within the eSIM profile. The device can select an application
  by reading the content of the Directory File. Each entry of EF_DIR consists of an application identifier and a label. Please fill out the
  table with AID and label of your choice.
</p>

<rs-guidance-box class="mb-4" i18n>
  Guidance: Please ensure to populate EF_DIR with the content of an intended application or applications for your eSIM profile. For example,
  if your eSIM profile is for data-only devices, only USIM is required. In this case, populate EF_DIR only with the AID/label of USIM.
</rs-guidance-box>

<div class="ml-6">
  <rs-error-message *ngIf="errorFound" class="mb-3" [message]="errorMessage" />
  <div style="width: 750px">
    <p-table
      showGridlines="true"
      stripedRows="true"
      [value]="profileValues.directoryFiles"
      [(selection)]="selectedDirectoryFiles"
      dataKey="id"
      styleClass="p-datatable-striped p-datatable-gridlines"
    >
      <ng-template pTemplate="caption">
        <div class="flex align-items-center gap-2">
          <p-button
            i18n-label
            label="Add"
            icon="pi pi-plus-circle"
            size="small"
            [outlined]="true"
            (onClick)="addDirectoryFile()"
          ></p-button>
          <p-button
            i18n-label
            label="Delete"
            icon="pi pi-trash"
            size="small"
            severity="danger"
            [outlined]="true"
            (onClick)="deleteDirectoryFiles()"
            [disabled]="!selectedDirectoryFiles || !selectedDirectoryFiles.length"
          ></p-button>
        </div>
      </ng-template>
      <ng-template pTemplate="colgroup">
        <colgroup>
          <col style="width: 3rem" />
          <col style="width: 7rem" />
          <col style="width: 25rem" />
          <col />
        </colgroup>
      </ng-template>
      <ng-template pTemplate="header">
        <tr>
          <th>
            <p-tableHeaderCheckbox></p-tableHeaderCheckbox>
          </th>
          <th i18n>Record #</th>
          <th i18n>Application Identifier</th>
          <th i18n>Label</th>
        </tr>
      </ng-template>
      <ng-template pTemplate="body" let-directoryFile let-rowIndex="rowIndex">
        <tr>
          <td style="text-align: center">
            <p-tableCheckbox [value]="directoryFile"></p-tableCheckbox>
          </td>
          <td style="text-align: center">{{ rowIndex + 1 }}</td>
          <td>
            <input
              pInputText
              rsHexOnlyInput
              class="maximize-inputs console-text"
              [maxlength]="32"
              [(ngModel)]="directoryFile.applicationIdentifier"
              (input)="handleFormEvents()"
            />
          </td>
          <td>
            <input
              (input)="handleFormEvents()"
              [(ngModel)]="directoryFile.label"
              class="console-text maximize-inputs"
              maxlength="32"
              type="text"
              pInputText
            />
          </td>
        </tr>
      </ng-template>
      <ng-template pTemplate="emptymessage">
        <tr>
          <td colspan="4" i18n>No records defined.</td>
        </tr>
      </ng-template>
    </p-table>
  </div>
</div>
